import React from "react";
import { FaLocationDot } from "react-icons/fa6";

export const Address = ({ address }) => {
  return (
    <address>
      <div>
        <span className="pe-2">
          <FaLocationDot />
        </span>
        <span>{address.address}</span>
        <br />
        <span>
          {address.city}, {address.state} {address.zipcode}
        </span>
      </div>
    </address>
  );
};
